class SplitContent extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (window.BAO.MediaBreakpoints.isXsViewport) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'mouseover', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    this.els.thumbnail.elements.forEach(thumbnailEl => {
      thumbnailEl.setAttribute(
        'aria-hidden',
        thumbnailEl.dataset.reference !== event.target.dataset.reference,
      )
    })
  }
}

if (!customElements.get('split-content')) {
  customElements.define('split-content', SplitContent)
}
